"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPointFromString = exports.getLineFromString = exports.getGeoJsonFromStringOrObject = void 0;
const getGeoJsonFromStringOrObject = (result) => {
    if (result && typeof result === 'string') {
        return JSON.parse(result);
    }
    else if (result && typeof result === 'object') {
        return result;
    }
    return null;
};
exports.getGeoJsonFromStringOrObject = getGeoJsonFromStringOrObject;
const getLineFromString = (result) => {
    const geoJson = exports.getGeoJsonFromStringOrObject(result);
    if (geoJson) {
        if (geoJson.type === 'LineString') {
            return geoJson;
        }
        else if (geoJson && geoJson.type === 'Feature') {
            if (geoJson.geometry.type === 'LineString') {
                return geoJson.geometry;
            }
        }
    }
    return null;
};
exports.getLineFromString = getLineFromString;
const getPointFromString = (result) => {
    const geoJson = exports.getGeoJsonFromStringOrObject(result);
    if (geoJson) {
        if (geoJson.type === 'Point') {
            return geoJson;
        }
        else if (geoJson && geoJson.type === 'Feature') {
            if (geoJson.geometry.type === 'Point') {
                return geoJson.geometry;
            }
        }
    }
    return null;
};
exports.getPointFromString = getPointFromString;
//# sourceMappingURL=helpers.js.map